<template>
  <div class="c-home-slider" :class="{'-active': state}">
    <div class="slot" v-show="false">
      <slot></slot>
    </div>
    <div class="c-home-slider__inner">
      <ul class="c-home-slider__list" :style="listStyle">
        <li class="c-home-slider__item" v-for="(item, i) in list" :key="i">
          <a :href="item.href" v-background="item.src" class="c-home-slider__anchor"></a>
        </li>
      </ul>
    </div>
    <nav class="c-home-slider__nav">
      <button class="c-home-slider__nav-button" @click="prev">
        <e-icon name="chevron-left"></e-icon>
      </button>
      <button class="c-home-slider__nav-button" @click="next">
        <e-icon name="chevron-right"></e-icon>
      </button>
    </nav>
    <ul class="c-home-slider__map">
      <li class="c-home-slider__map-point" v-for="(item, i) in list" :key="i" :class="{'-active': index === i}" @click="show(i)">
        <e-icon name="diamond"></e-icon>
      </li>
    </ul>
  </div>
</template>

<script>

import Icon from "../element/icon.vue";
import u from "../lib/u.js";

export default {

  components: {
    "e-icon": Icon
  },

  data (){
    return {
      mobile: false,
      state: false,
      list: [],
      index: 0,
      interval: 8000,
      timer: null,
      touchStartX: 0,
      touchStartTime: 0,
    }
  },

  computed: {
    listStyle (){
      const pos = this.index * 100;
      return {
        "transform": `translateX(-${pos}%)`
      }
    }
  },

  mounted (){
    this.list = Array.from(this.$el.querySelectorAll(".slot li"))
    .map((li, i) => {
      return {
        index: i,
        // src: u.exists(li.querySelector("img"), "src"),
        src: u.parseSrcset(li.querySelector("img")),
        href: u.exists(li.querySelector("a"), "href")
      };
    });

    this.mobile = ("ontouchstart" in window) && $(window).width() < 640;

    if(this.mobile){
      $(this.$el).on("touchstart touchmove touchend", this.onTouch);
    }

    setTimeout(() => {
      this.state = true;
      this.start();
    }, 100);
  },

  directives: {
    background (el, o){
      el.style.backgroundImage = `url(${o.value})`;
    }
  },

  methods: {
    start (){
      if(this.timer){
        clearInterval(this.timer);
      }
      this.timer = setInterval(this.next, this.interval);
    },
    next (e){
      this.index = (this.index + 1) % this.list.length;
      if(e){
        this.start();
      }
    },
    prev (e){
      let index = this.index - 1;
      index = index < 0 ? this.list.length - 1 : index;
      this.index = index;
      if(e){
        this.start();
      }
    },
    show (index){
      this.index = index;
      this.start();
    },
    onTouch (e){
      let x = (e.type === "touchend") ? e.originalEvent.changedTouches[0].clientX : e.originalEvent.touches[0].clientX;
      let d;

      switch(e.type){
        case "touchstart":
          this.touchStartX = x;
          this.touchStartTime = (new Date()).getTime();
          break;
        case "touchmove":
          e.preventDefault();
          break;
        case "touchend":
          d = x - this.touchStartX;
          if(Math.abs(d) < 50){
            break;
          }
          if(d > 0){
            this.prev(true);
          } else {
            this.next(true);
          }
          this.touchStartX = 0;
          e.preventDefault();
          break;
        default: break;
      }
    }
  }
  
}
</script>



// WEBPACK FOOTER //
// src/component/home-slider.vue